import {
    FETCH_CHARTS_STARTED,
    FETCH_CHARTS_SUCCESS,
    FETCH_CHARTS_ERROR,
} from './types';

export const fetchChartsStartedAction = () => ({
    type        : FETCH_CHARTS_STARTED,
})
export const fetchChartsSuccessAction = (charts: any) => ({
    type        : FETCH_CHARTS_SUCCESS,
    charts
})